export const environment = {
	// # -----------------------------------------------------------------------------
	// # General
	// # -----------------------------------------------------------------------------
	// @ts-ignore
	production: window['env']['environment'] === 'production',
	// @ts-ignore
	gatewayURL: window['env']['gatewayURL'] || 'http://localhost:3002',
	// @ts-ignore
	inactivityInMinutes: window['env']['inactivityInMinutes'] || 10,
	// @ts-ignore
	globalSessionTimeout: window['env']['globalSessionTimeout'] || 60,
	// @ts-ignore
	baseUrl: `${window['env']['gatewayURL']}/v1/sigp`,
	// @ts-ignore
	urlApiValleLab: `${window['env']['gatewayURL']}/v1/hvi`,
	// @ts-ignore
	localSecret: window['env']['localSecret'] || false,
	// # -----------------------------------------------------------------------------
	// # Enlaces a servicios externos
	// # -----------------------------------------------------------------------------
	// @ts-ignore
	urlApiSegVial: window['env']['urlApiSegVial'] || false,
	// @ts-ignore
	urlApiValleMagico: window['env']['urlApiValleMagico'] || false,
	// @ts-ignore
	urlApiPertenezco: window['env']['urlApiPertenezco'] || false,
	// @ts-ignore
	urlApiGestionPedagogica: window['env']['urlApiGestionPedagogica'] || false,
	// @ts-ignore
	urlApiSapereAude: window['env']['urlApiSapereAude'] || false,
	// @ts-ignore
	urlApiCanvas: window['env']['urlApiCanvas'] || false,
	// @ts-ignore
	urlApiCatedra: window['env']['urlApiCatedra'] || false,
	// @ts-ignore
	userSegVial: window['env']['userSegVial'] || false,
	// @ts-ignore
	passwordSegVial: window['env']['passwordSegVial'] || false,
	// @ts-ignore
	urlSST: `${window['env']['urlSST']}` || false,
	// # -----------------------------------------------------------------------------
	// # Chatbot
	// # -----------------------------------------------------------------------------
	// @ts-ignore
	urlChatBot: window['env']['urlChatBot'] || false,
	// @ts-ignore
	chatBotSrc: window['env']['chatBotSrc'] || false,
	// @ts-ignore
	chatBotToken: window['env']['chatBotToken'] || false,
	// @ts-ignore
	chatBotUrl: window['env']['chatBotUrl'] || false,
	// @ts-ignore
	chatBotId: window['env']['chatBotId'] || false,
	// # -----------------------------------------------------------------------------
	// # Enlaces a Soporte
	// # -----------------------------------------------------------------------------
	// @ts-ignore
	requestSupportLink: window['env']['requestSupportLink'],
};
